/**
 * EDITAR DATOS DE LA FICHA DE UN COLABORADOR (COLABORADOR-EDITAR-NOMBRE-T1, Josse 3-nov).
 *
 * Josse no tenia como corregir desde la ficha unica el nombre de un colaborador (el Propietario quedo llamado como la
 * empresa). La ficha manda el mismo PUT colaboradores/{id} que la lista; con nexo-api 782 la persona toma el nombre
 * de su ficha (trigger en la base), asi que no hay otra ruta. Sin DOM: lo prueba scripts/check-datos-de-la-ficha.mjs.
 *
 * @module application/personas/datosDeLaFicha
 */

const texto = (v) => String(v ?? '').trim();

/** Lo que el formulario muestra al abrir, leido de GET colaboradores/{id} (camelCase o PascalCase). */
export function datosDelColaborador(c) {
  const v = (k) => texto(c?.[k] ?? c?.[k[0].toUpperCase() + k.slice(1)]);
  return { nombre: v('nombreCompleto'), documento: v('documento'), telefono: v('telefono') };
}

/**
 * El cuerpo del PUT, con las claves del DTO (UpdateColaboradorRequest, camelCase). El nombre es obligatorio: la API
 * guarda un vacio y la persona no lo toma, asi que el panel no lo manda. Documento y telefono vacios se mandan vacios
 * (es la forma de borrarlos).
 */
export function cuerpoDeDatos({ nombre, documento, telefono } = {}) {
  const n = texto(nombre);
  if (!n) return { ok: false, campo: 'nombre', error: 'Escribe el nombre: no puede quedar vacío.' };
  if (n.length > 200) return { ok: false, campo: 'nombre', error: 'El nombre pasa de 200 letras.' };
  return { ok: true, cuerpo: { nombreCompleto: n, documento: texto(documento), telefono: texto(telefono) } };
}

/** La frase despues de guardar: dice que quedo y que no, sin adornos. */
export function fraseDeDatos(res) {
  if (res?.ok) return { ok: true, frase: 'Guardado. La ficha se vuelve a leer con los datos nuevos.' };
  return { ok: false, frase: 'No se guardó: ' + (texto(res?.error) || 'la API no respondió.') };
}
